import type { EmployeeAlertFirstContractStartDateNotSameAsHiredDate } from '@/common/graphql';

import { FormattedDate } from '../FormattedDate';

export const DetailDescriptionEmployeeAlertFirstContractStartDateNotSameAsHiredDate = ({
  reason,
}: {
  reason: Pick<EmployeeAlertFirstContractStartDateNotSameAsHiredDate, 'hiredDate' | 'firstStartDate'>;
}) => (
  <>
    <div>
      <FormattedDate prefix="Hired date" date={reason.hiredDate} />
    </div>
    <div>
      <FormattedDate prefix="First contract start date" date={reason.firstStartDate} />
    </div>
  </>
);
